import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { MenuActive } from '@modules/practitioner/practitioner-module';
// import { useTranslation } from 'react-i18next';
import FormDevices from '@modules/devices/components/form-new-device/FormDevices';
import DevicesListScreen from '@modules/devices/components/devices-list/DevicesListScreen';
// import { getPractitionerOrganization } from '@services/services/servies';
import { useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { getDevices } from '@modules/devices/utils/devices';
import { ISelectItem, newDeviceProps } from '@modules/devices/types/types-devices';
import Host from '@interfaces/device/host';
import { getActiveDeviceTypes } from '@services/device/deviceType';
import useOfficesByPractitioner from '@customHooks/practitioner/use-practitioner-offices';

interface initData  {
    content: Array<newDeviceProps>,
    numberOfElements: number,
    totalElements: number,
    totalPages: number
}

type Props = {
    name: string
    changeComponent: () => void
    setBullets: () => void
    organizationHostId: string
    hostToDevice?: Host
};

const DevicesScreen:FC<Props> = ({changeComponent, setBullets, organizationHostId, hostToDevice}: Props) => {
    const { setMenuActive } = useContext(MenuActive);
    const session = useSelector((state: RootState) => state.session);
    const organization = useSelector((state: RootState) => state.organizations);

    const [{content}, setInitData] = useState<initData>({
        content: [],
        numberOfElements: 0,
        totalElements: 0,
        totalPages: 0
    });
    const [showForm, setShowForm] = useState(false);
    const practitionerProfile = useSelector((state: RootState) => state.practitionerProfile)
    const { offices: officesMongo} = useOfficesByPractitioner(practitionerProfile.practitionerProfile?.username ?? "",  organization.organizationId,  organization.predeterminedDrProx)
    // const [offices, setOffices] = useState<InstitutionI[]>([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isReady, setIsReady] = useState<boolean>(false);
    const [deviceEdit, setDeviceEdit] = useState<newDeviceProps>();
    const [deviceTypes, setDeviceTypes] = useState<ISelectItem[]>([]);

    const toggleShowForm = () => {
        setShowForm(!showForm);
    }



    const setDeviceToEdit = (device?:newDeviceProps) => {
        setDeviceEdit(device);
        setIsEditing(true);
        toggleShowForm();
    }

    const updateDevices=()=>{
        loadDevices() 
    }

    const loadDevices = useCallback(() => {
        getDevices(organizationHostId).then(resp => {
        setInitData(resp.data);
        setIsReady(true)
        });
    },[organizationHostId]);

    useEffect(() => {
        getActiveDeviceTypes()
        .then(result => {
            const items = result.map(dev => {
            return {
                value: dev.code, 
                option: dev.description
            } as ISelectItem;
            });

            console.debug("Items retrieved", items);
            setDeviceTypes(items);
        })
        .catch(error => {
            const msg = "Could not load device types";
            console.error(msg, error);
            throw new Error(msg);
        });
    }, []);


    useEffect(() => {
        setMenuActive('devices')
    })

    useEffect(() => {
        loadDevices()
    }, [showForm,loadDevices]);

    useEffect(() => {
        if(!showForm)
        setDeviceEdit(undefined);
    }, [showForm]);

    useEffect(() => {
        setBullets()
    }, [setBullets])

    return ( showForm ?
        <FormDevices
        onToggle={() => toggleShowForm()}
        offices={officesMongo ?? []}
        deviceToEdit={deviceEdit}
        isEditing={isEditing}
        organizationHostId={organizationHostId}
        deviceTypes={deviceTypes} />:
        <DevicesListScreen
        onToggle={() => toggleShowForm()}
        devices={content}
        ready={isReady}
        setDeviceEdit={setDeviceToEdit}
        addNewDevice={() => setIsEditing(false)}
        hostToDevice={hostToDevice}
        updateDevices={() => updateDevices()}
        />
    )
}

export default DevicesScreen;
